export default __webpack_public_path__ + "static/media/General's Boots of the Ascending Kingdom.11c54c8e.jpg";